function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 11.5,
  fill: "#006AFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 19.5511L12.4385 19.1682C16.1258 15.9485 18 13.1372 18 10.666C18 7.16646 15.2686 4.66602 12 4.66602C8.73137 4.66602 6 7.16646 6 10.666C6 13.1372 7.87421 15.9485 11.5615 19.1682L12 19.5511ZM12 17.775C8.87107 14.955 7.33333 12.5655 7.33333 10.666C7.33333 7.93042 9.44274 5.99935 12 5.99935C14.5573 5.99935 16.6667 7.93042 16.6667 10.666C16.6667 12.5655 15.1289 14.955 12 17.775ZM12 7.33268C13.8409 7.33268 15.3333 8.82507 15.3333 10.666C15.3333 12.507 13.8409 13.9993 12 13.9993C10.1591 13.9993 8.66667 12.507 8.66667 10.666C8.66667 8.82507 10.1591 7.33268 12 7.33268ZM10 10.666C10 9.56145 10.8954 8.66602 12 8.66602C13.1046 8.66602 14 9.56145 14 10.666C14 11.7706 13.1046 12.666 12 12.666C10.8954 12.666 10 11.7706 10 10.666Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 11.5,
  stroke: "#006AFF"
});

function SvgPinNewTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = React.forwardRef(SvgPinNewTheme);
export default __webpack_public_path__ + "static/media/pin-new-theme.3dca36b5.svg";
export { ForwardRef as ReactComponent };